import { addDays } from 'date-fns';

// unit calculations
export const calculationOfLaborCost = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const laborUnitPrice = keyName === 'labor_unit_price' ? data : getValues('labor_unit_price');
  const laborCost = laborUnitPrice && quantity ? laborUnitPrice * quantity : 0;

  setValue('labor_cost', laborCost);
  calculationOfDirectCost(setValue, getValues)(laborCost, 'labor_cost');
  calculationOfLabourHrs(setValue, getValues)(laborCost, 'labor_cost');
};

export const calculationOfMaterialCost = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const materialUnitPrice =
    keyName === 'material_unit_price' ? data : getValues('material_unit_price');
  const materialCost = materialUnitPrice && quantity ? materialUnitPrice * quantity : 0;

  setValue('material_cost', materialCost);
  calculationOfDirectCost(setValue, getValues)(materialCost, 'material_cost');
};

export const calculationOfEquipmentCost = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const equipmentUnitPrice =
    keyName === 'equipment_unit_price' ? data : getValues('equipment_unit_price');
  const equipmentCost = equipmentUnitPrice && quantity ? equipmentUnitPrice * quantity : 0;

  setValue('equipment_cost', equipmentCost);
  calculationOfDirectCost(setValue, getValues)(equipmentCost, 'equipment_cost');
};

export const calculationOfSubcontractorCost = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const subcontractorUnitPrice =
    keyName === 'subcontractor_unit_price' ? data : getValues('subcontractor_unit_price');
  const subcontractorCost =
    subcontractorUnitPrice && quantity ? subcontractorUnitPrice * quantity : 0;

  setValue('subcontractor_cost', subcontractorCost);
  calculationOfDirectCost(setValue, getValues)(subcontractorCost, 'subcontractor_cost');
};

// detail calculations
export const calculationOfWorkdays = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const productionRate =
    keyName === 'daily_production_rate_per_shift'
      ? data
      : getValues('daily_production_rate_per_shift');
  const difficultyFactor = keyName === 'difficulty_factor' ? data : getValues('difficulty_factor');
  const noOfShifts = keyName === 'no_of_shifts' ? data : getValues('no_of_shifts');

  const workDays =
    quantity && productionRate && difficultyFactor && noOfShifts
      ? quantity / productionRate / difficultyFactor / noOfShifts
      : 0;

  setValue('work_days', workDays);
  calculationOfLaborHrsInDetail(setValue, getValues)(workDays, 'work_days');

  // change duration
  const duration = Number(workDays);
  if (!isNaN(duration) && typeof duration === 'number') {
    console.log(duration, 'here is duration');
    const startDate = getValues('start_date');
    if (startDate) {
      const endDate = addDays(new Date(startDate), duration);
      setValue('duration', duration.toFixed(2));
      setValue('end_date', endDate);
    }
  }
};

export const calculationOfLaborHrsInDetail = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const workDays = keyName === 'work_days' ? data : getValues('work_days');
  const noOfWorkers = keyName === 'number_of_workers' ? data : getValues('number_of_workers');
  const shiftHours = keyName === 'shift_hours' ? data : getValues('shift_hours');
  const noOfShifts = keyName === 'no_of_shifts' ? data : getValues('no_of_shifts');

  const laborHoursInDetail =
    workDays && noOfWorkers && shiftHours && noOfShifts
      ? workDays * noOfWorkers * shiftHours * noOfShifts
      : 0;

  setValue('labor_hours', laborHoursInDetail.toFixed(2));
  calculationOfLaborCostInDetail(setValue, getValues)(laborHoursInDetail, 'labor_hours');
};

export const calculationOfLaborCostInDetail = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const laborHoursInDetail = keyName === 'labor_hours' ? data : getValues('labor_hours');
  const laborHourlyRate = keyName === 'labor_hourly_rate' ? data : getValues('labor_hourly_rate');
  const laborCost =
    laborHoursInDetail && laborHourlyRate ? laborHoursInDetail * laborHourlyRate : 0;

  setValue('labor_cost', laborCost);
  calculationOfDirectCost(setValue, getValues)(laborCost, 'labor_cost');
  calculationOfLaborUnitPrice(setValue, getValues)(laborCost, 'labor_cost');
};

// unit calculations && detail calculations
export const calculationOfLaborUnitPrice = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const quantity = keyName === 'quantity' ? data : getValues('quantity');
  const laborCost = keyName === 'labor_cost' ? data : getValues('labor_cost');
  const laborUnitPrice = laborCost && quantity ? laborCost / quantity : 0;

  setValue('labor_unit_price', laborUnitPrice);
};

// base calculations
export const calculationOfLabourHrs = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const laborCost = keyName === 'labor_cost' ? data : getValues('labor_cost');
  const laborHourlyRate = keyName === 'labor_hourly_rate' ? data : getValues('labor_hourly_rate');
  const laborHours = laborCost && laborHourlyRate ? laborCost / laborHourlyRate : 0;
  setValue('labor_hours', laborHours.toFixed(2));
};

export const calculationOfDirectCost = (setValue, getValues) => (data, keyName) => {
  if (keyName !== 'labor_cost') {
    setValue(keyName, data);
  }

  const costKeys = [
    'labor_cost',
    'material_cost',
    'equipment_cost',
    'subcontractor_cost',
    'other_cost',
  ];

  const directCost = costKeys.reduce((total, costKey) => {
    const value = costKey === keyName ? data : getValues(costKey);
    return total + (parseFloat(value) || 0); // Ensure numbers are parsed, defaulting to 0 if undefined
  }, 0);
  const quantity = getValues('quantity');
  if (quantity > 0) {
    setValue('direct_unit_price', (directCost / quantity).toFixed(2));
  } else {
    setValue('direct_unit_price', 0);
  }
  calculateMarkUpCost(setValue, getValues, directCost);
};

export const calculationOfDirectUnitPrice = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const directCost = getValues('direct_cost');
  const directUnitPrice = data ? directCost / data : 0;
  setValue('direct_unit_price', directUnitPrice.toFixed(2));
};

export const calculationOfDirectCostInSimpleResource = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);

  const quantity = keyName === 'quantity' ? data || 0 : getValues('quantity') || 0;
  const unitPrice =
    keyName === 'direct_unit_price' ? data || 0 : getValues('direct_unit_price') || 0;

  const directCost = quantity * unitPrice;
  calculateMarkUpCost(setValue, getValues, directCost);
};

export const calculationOfMarkupCost = (setValue, getValues) => (data, keyName) => {
  setValue(keyName, data);
  const directCost = getValues('direct_cost');
  const directUnitPrice = directCost ? (data / 100) * directCost : 0;
  setValue('mark_up_cost', directUnitPrice.toFixed(2));
  calculateMarkupBidAmount(setValue, getValues, 'mark_up_cost', directUnitPrice);
};

export const setMarkupBidAmount = (bidAmount, quantity, setValue) => {
  setValue('bid_amount', bidAmount.toFixed(2));
  if (quantity > 0) {
    setValue('bid_unit_price', (bidAmount / quantity).toFixed(2));
  } else {
    setValue('bid_unit_price', 0);
  }
};

export const calculationOfMarkupBidUnitPrice = (setValue, getValues) => (data, keyName) => {
  const markupBidAmout = getValues('bid_amount');
  const bidUnitPrice = markupBidAmout / data;
  setValue('bid_unit_price', bidUnitPrice.toFixed(2));
};

const calculateMarkUpCost = (setValue, getValues, directCost) => {
  setValue('direct_cost', directCost.toFixed(2));
  const markUpPercent = getValues('mark_up_percent');
  if (markUpPercent > 0) {
    setValue('mark_up_cost', ((markUpPercent / 100) * directCost).toFixed(2));
  } else {
    setValue('mark_up_cost', 0);
  }
  calculateMarkupBidAmount(setValue, getValues, 'direct_cost', directCost);
};

const calculateMarkupBidAmount = (setValue, getValues, keyName, data) => {
  const costKeys = ['direct_cost', 'mark_up_cost'];

  const bidAmount = costKeys.reduce((total, costKey) => {
    const value = costKey === keyName ? data : getValues(costKey);
    return total + (parseFloat(value) || 0);
  }, 0);
  const quantity = getValues('quantity');
  setMarkupBidAmount(bidAmount, quantity, setValue);
};
